import React, { useEffect, useState } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  Row,
  Col,
  Input,
  Button
} from "reactstrap";
import { FaTrash } from "react-icons/fa";
import axios from "../../../../utills/api";

const API_BASE = "/housekeeping-services";

const HousekeepingCategoryModal = ({
  isOpen,
  toggle
}) => {
  const [categories, setCategories] = useState([]);
  const [newCategory, setNewCategory] = useState("");

  const token = localStorage.getItem("token");

  const axiosConfig = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  const fetchCategories = async () => {
    try {
      const res = await axios.get(
        `${API_BASE}/categories`,
        axiosConfig
      );

      setCategories(
        Array.isArray(res.data)
          ? res.data
          : []
      );
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    if (isOpen) {
      fetchCategories();
    }
  }, [isOpen]);

  const handleCreateCategory = async () => {
    if (!newCategory.trim()) {
      return alert("Enter category name");
    }

    try {
      const res = await axios.post(
        `${API_BASE}/categories`,
        {
          name: newCategory.trim(),
        },
        axiosConfig
      );

      setCategories((prev) => [
        ...prev,
        res.data,
      ]);

      setNewCategory("");
    } catch (err) {
      console.error(err);

      alert(
        err.response?.data?.message ||
        "Failed to create category"
      );
    }
  };

  const handleDeleteCategory = async (
    categoryId
  ) => {
    if (
      !window.confirm(
        "Delete this category?"
      )
    )
      return;

    try {
      await axios.delete(
        `${API_BASE}/categories/${categoryId}`,
        axiosConfig
      );

      setCategories((prev) =>
        prev.filter(
          (item) =>
            item._id !== categoryId
        )
      );
    } catch (err) {
      console.error(err);

      alert(
        err.response?.data?.message ||
        "Failed to delete category"
      );
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      size="lg"
    >
      <ModalHeader toggle={toggle}>
        Housekeeping Categories
      </ModalHeader>

      <ModalBody>

        <Row className="mb-4">
          <Col md={8}>
            <Input
              type="text"
              placeholder="Enter category name"
              value={newCategory}
              onChange={(e) =>
                setNewCategory(
                  e.target.value
                )
              }
            />
          </Col>

          <Col md={4}>
            <Button
              color="success"
              onClick={
                handleCreateCategory
              }
            >
              Create Category
            </Button>
          </Col>
        </Row>

        <Row>
          {categories.length === 0 ? (
            <Col>
              <p className="text-muted">
                No categories found
              </p>
            </Col>
          ) : (
            categories.map((cat) => (
              <Col
                md={4}
                key={cat._id}
                className="mb-3"
              >
                <div
                  className="d-flex justify-content-between align-items-center p-2 border rounded"
                >
                  <span>
                    {cat.name}
                  </span>

                  <FaTrash
                    className="text-danger"
                    style={{
                      cursor:
                        "pointer",
                    }}
                    onClick={() =>
                      handleDeleteCategory(
                        cat._id
                      )
                    }
                  />
                </div>
              </Col>
            ))
          )}
        </Row>

      </ModalBody>
    </Modal>
  );
};

export default HousekeepingCategoryModal;